"use client"

import { useEffect, useState } from "react"

interface VenueMarkets {
  hyperliquid: string[]
  orderly: string[]
  jupiter: string[]
}

let _cache: VenueMarkets | null = null
let _promise: Promise<VenueMarkets> | null = null

async function fetchVenueMarkets(): Promise<VenueMarkets> {
  if (_cache) return _cache
  if (_promise) return _promise
  const apiUrl = process.env.NEXT_PUBLIC_BACKEND_URL || "http://localhost:8000"
  _promise = fetch(`${apiUrl}/api/exchange/venue-markets`)
    .then((r) => r.json())
    .then((data) => {
      _cache = data
      return data as VenueMarkets
    })
    .catch(() => ({ hyperliquid: [], orderly: [], jupiter: [] }))
  return _promise
}

export function useVenueMarkets() {
  const [markets, setMarkets] = useState<VenueMarkets | null>(_cache)

  useEffect(() => {
    if (_cache) return
    fetchVenueMarkets().then(setMarkets)
  }, [])

  function getVenuesForCoin(coin: string): string[] {
    if (!markets) return []
    const c = coin.toUpperCase().replace(/USDT$|USDC$|-PERP$|_PERP$/i, "")
    const result: string[] = []
    if (markets.hyperliquid.includes(c)) result.push("hyperliquid")
    if (markets.orderly.includes(c)) result.push("orderly")
    if (markets.jupiter.includes(c)) result.push("jupiter")
    return result
  }

  return { getVenuesForCoin }
}
